export interface TranscriptScrollTarget {
  scrollHeight: number;
  scrollTo(options: ScrollToOptions): void;
}

export function scrollTranscriptToBottom(
  transcript: TranscriptScrollTarget,
  behavior: ScrollBehavior = "smooth"
): void {
  transcript.scrollTo({ top: transcript.scrollHeight, left: 0, behavior });
}
